import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

const routes: Routes = [
  { path: 'admin',loadChildren: () => import('./admin/admin.module').then(m => m.AdminModule)},
  { path: 'owner',loadChildren: () => import('./owner/owner.module').then(m => m.OwnerModule)},
  { path: '',redirectTo: '/admin/station',pathMatch: 'full'}
];

@NgModule({
  imports: [RouterModule.forRoot(routes,{ useHash: true })],
  exports: [RouterModule],
  providers: []
})
export class AppRoutingModule { }
